import React from "react"

const Button = ({ text, onClick, style, variant }) => {
  const baseStyle = {
    padding: "10px 16px",
    fontSize: "12px",
    borderRadius: "5px",
    cursor: "pointer",
    border: "1px solid orange",
    margin: "5px",
  }

  const variantStyle =
    variant === "filled"
      ? {
          backgroundColor: "#FF8616",
          color: "white",
        }
      : {
          backgroundColor: "white",
          color: "#FF8616",
        }

  const combinedStyle = { ...baseStyle, ...variantStyle, ...style }

  return (
    <button onClick={onClick} style={combinedStyle}>
      {text}
    </button>
  )
}

export default Button
